<template>
  <div class="coupon-modal">
    <popup ref="popup" :noActions="true" :scrolling="true">
      <coupon
        v-if="coupon"
        v-bind="$attrs"
        v-on="$listeners"
        :coupon="coupon"
        @confirmed="confirmed"
        :showCode="showCode"
        :showQrcodeButton="showQrcodeButton"
      />
      <temp-coupon
        v-else-if="redeemCodeBundleId"
        v-bind="$attrs"
        v-on="$listeners"
        :redeem-code-bundle-id="redeemCodeBundleId"
        @redeemed="redeemed"
      />
    </popup>
  </div>
</template>

<script>
import Popup from "@/components/Page/Liff/Shared/Popup.vue";
import Coupon from "./Coupon";
import TempCoupon from "./TempCoupon";

export default {
  components: { Popup, Coupon, TempCoupon },
  props: {
    coupon: {
      type: Object,
      default: null,
    },
    redeemCodeBundleId: {
      type: String,
      default: null,
    },
    showCode: {
      type: Boolean,
      default: true,
    },
    showQrcodeButton: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    open() {
      this.$refs.popup.open();
    },
    close() {
      this.$refs.popup.close();
    },
    confirmed() {
      this.$refs.popup.close();
      this.$emit("confirmed");
    },
    redeemed(couponId) {
      this.$refs.popup.close();
      this.$emit("redeemed", couponId);
    },
  },
};
</script>

<style lang="scss" scoped>
.coupon-modal {
  ::v-deep .popup__header {
    margin-bottom: 0px;
  }

  ::v-deep .popup__panel {
    background-color: transparent;

    padding: 0;

    box-shadow: none;
  }

  ::v-deep .popup__body.scrolling {
    height: auto;
  }
}
</style>
